import React from 'react'

const Footer = () => {
    return (
        <footer>
            <p className='wordmark'>Liina Dance Studio</p>
            <p className='copyright'>© Liina Dance Studio</p>
        </footer>
    )
}

export default Footer
